(function () {
  'use strict';
  var hs = window.hs || { routes: {}, strings: {}, cartType: 'drawer' };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function lock(on) { document.body.classList.toggle('no-scroll', !!on); }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  var toastTimer;
  function toast(msg) {
    var t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 3200);
  }

  /* ---------- cart drawer ---------- */
  function drawer() { return $('[data-cart-drawer]'); }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !(parseInt(n, 10) > 0); });
  }
  function openCart() {
    var d = drawer(); if (!d) return false;
    d.classList.add('is-open'); lock(true);
    var p = $('.cart-drawer__panel', d); if (p) p.focus();
    return true;
  }
  function closeCart() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open'); lock(false);
  }
  function renderDrawer(html) {
    var doc = parse(html);
    var next = $('[data-cart-drawer-inner]', doc), cur = $('[data-cart-drawer-inner]');
    if (next && cur) cur.innerHTML = next.innerHTML;
    var root = $('[data-cart-drawer]', doc);
    if (root) setCount(root.getAttribute('data-count'));
  }
  function refreshDrawer() {
    return fetch(hs.routes.cart + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j['cart-drawer']) renderDrawer(j['cart-drawer']); });
  }

  /* ---------- add to cart ---------- */
  function showFormError(form, msg) {
    var el = $('[data-form-error]', form);
    if (el) { el.textContent = msg; el.hidden = false; } else { toast(msg); }
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches && form.matches('[data-filter-form]')) {
      $$('input[type=number]', form).forEach(function (i) { if (i.value === '') i.disabled = true; });
      return;
    }
    if (!form.matches || !form.matches('form[data-ajax-cart]')) return;
    if (hs.cartType !== 'drawer' || !drawer()) return;
    e.preventDefault();
    var btn = $('[type=submit]', form);
    if (btn && (btn.disabled || btn.classList.contains('is-loading'))) return;
    var err = $('[data-form-error]', form); if (err) err.hidden = true;
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    if (btn) btn.classList.add('is-loading');
    fetch(hs.routes.cartAdd + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { showFormError(form, res.description || res.message || hs.strings.error); return; }
        if (res.sections && res.sections['cart-drawer']) renderDrawer(res.sections['cart-drawer']); else refreshDrawer();
        closeDialog(); openCart();
      })
      .catch(function () { showFormError(form, hs.strings.error); })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    var change = t.closest && t.closest('[data-cart-change]');
    if (change) {
      e.preventDefault();
      fetch(hs.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(change.getAttribute('data-line'), 10), quantity: parseInt(change.getAttribute('data-quantity'), 10), sections: 'cart-drawer', sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        if (cart.sections && cart.sections['cart-drawer']) renderDrawer(cart.sections['cart-drawer']); else refreshDrawer();
        if (cart.status && cart.message) toast(cart.message);
      }).catch(function () { toast(hs.strings.error); });
      return;
    }
    var openLink = t.closest && t.closest('[data-cart-open]');
    if (openLink && hs.cartType === 'drawer' && drawer()) { e.preventDefault(); refreshDrawer().then(openCart, openCart); return; }
    if (t.closest && t.closest('[data-cart-close]')) { closeCart(); return; }

    var qm = t.closest && t.closest('[data-qty-minus],[data-qty-plus]');
    if (qm) {
      var input = $('.qty__input', qm.closest('[data-qty]'));
      if (input) {
        var v = parseInt(input.value, 10) || 1;
        v += qm.hasAttribute('data-qty-plus') ? 1 : -1;
        input.value = Math.max(parseInt(input.min, 10) || 1, v);
      }
      return;
    }

    var gimg = t.closest && t.closest('.gallery__slide img');
    if (gimg && window.matchMedia('(min-width: 750px)').matches) { openLightbox(gimg); return; }
    var lbc = t.closest && t.closest('[data-lb]');
    if (lbc) {
      if (t.closest('[data-lb-prev]')) lbStep(-1); else if (t.closest('[data-lb-next]')) lbStep(1);
      else if (!(t.classList && t.classList.contains('lb__img'))) closeLightbox();
      return;
    }

    var thumb = t.closest && t.closest('[data-thumb]');
    if (thumb) {
      var g = thumb.closest('[data-gallery]');
      activateMedia(g, thumb.getAttribute('data-thumb'));
      return;
    }

    var psw = t.closest && t.closest('[data-pc-swatch]');
    if (psw) { e.preventDefault(); pcSelect(psw); return; }

    var sw = t.closest && t.closest('[data-fc-swatch]');
    if (sw) { pickFeaturedColor(sw); return; }

    var tog = t.closest && t.closest('[data-menu-toggle]');
    if (tog) {
      var nav = $('[data-site-nav]');
      var open = nav.classList.toggle('is-open');
      tog.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    var ft = t.closest && t.closest('[data-filters-toggle]');
    if (ft) {
      var panel = $('[data-filters]');
      var show = panel.hidden;
      panel.hidden = !show;
      ft.setAttribute('aria-expanded', show ? 'true' : 'false');
      return;
    }

    var so = t.closest && t.closest('[data-search-open]');
    if (so) { e.preventDefault(); openSearch(); return; }
    if (t.closest && t.closest('[data-search-close]')) { closeSearch(); return; }

    var qa = t.closest && t.closest('[data-quick-add]');
    if (qa) { e.preventDefault(); openQuickAdd(qa.getAttribute('data-quick-add'), qa); return; }
    if (t.closest && t.closest('[data-dialog-close]')) { closeDialog(); return; }
    if (t.matches && t.matches('[data-quick-add-dialog]')) { closeDialog(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeCart(); closeSearch(); closeLightbox();
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    var auto = t.closest && t.closest('[data-auto-submit]');
    if (auto || (t.matches && t.matches('[data-auto-submit]'))) {
      var f = t.closest('[data-filter-form]'); if (f) { f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); f.submit(); }
      return;
    }
    var loc = t.closest && t.closest('[data-localization]');
    if (loc) { loc.submit(); return; }
    var info = t.closest && t.closest('[data-product-info]');
    if (info && t.closest('[data-variant-picker]')) updateVariant(info);
  });

  /* ---------- variants ---------- */
  function variantsOf(info) {
    var s = $('script[data-variants]', info);
    try { return JSON.parse(s.textContent); } catch (err) { return []; }
  }
  function selectedOptions(info) {
    return $$('[data-option-index]', info).map(function (fs) {
      var sel = $('select', fs); if (sel) return sel.value;
      var c = $('input:checked', fs); return c ? c.value : null;
    });
  }
  function findVariant(list, opts) {
    for (var i = 0; i < list.length; i++) {
      var ok = true;
      for (var j = 0; j < opts.length; j++) { if (list[i].options[j] !== opts[j]) { ok = false; break; } }
      if (ok) return list[i];
    }
    return null;
  }
  function markAvailability(info, list, opts) {
    $$('[data-option-index]', info).forEach(function (fs, i) {
      $$('input[type=radio]', fs).forEach(function (inp) {
        var avail = list.some(function (v) {
          if (v.options[i] !== inp.value || !v.available) return false;
          for (var j = 0; j < opts.length; j++) { if (j !== i && v.options[j] !== opts[j]) return false; }
          return true;
        });
        var label = fs.querySelector('label[for="' + inp.id + '"]');
        if (label) label.classList.toggle('is-unavailable', !avail);
      });
    });
  }
  function activateMedia(gallery, id) {
    if (!gallery || !id) return;
    var slide = $('[data-media-id="' + id + '"]', gallery);
    if (!slide) return;
    $$('.gallery__slide', gallery).forEach(function (s) { s.classList.toggle('is-active', s === slide); });
    $$('.gallery__thumb', gallery).forEach(function (th) { th.classList.toggle('is-active', th.getAttribute('data-thumb') === String(id)); });
    var phone = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    if (gallery.classList.contains('gallery--stacked') && !phone) slide.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' });
  }
  function updateVariant(info) {
    var list = variantsOf(info), opts = selectedOptions(info), v = findVariant(list, opts);
    $$('[data-option-index]', info).forEach(function (fs, i) {
      var l = $('[data-option-label]', fs); if (l) l.textContent = opts[i];
    });
    markAvailability(info, list, opts);
    var btn = $('[data-add]', info), idInput = $('[data-variant-id]', info);
    if (!v) { if (btn) { btn.disabled = true; btn.textContent = hs.strings.unavailable; } return; }
    if (idInput) idInput.value = v.id;
    var price = $('[data-price]', info), cmp = $('[data-compare]', info), wrap = $('[data-price-wrap]', info);
    if (price) price.textContent = v.price;
    if (cmp) { cmp.textContent = v.compare; cmp.hidden = !v.compare; }
    if (wrap) wrap.classList.toggle('price--sale', !!v.compare);
    if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? hs.strings.addToBag : hs.strings.soldOut; }
    var root = info.closest('[data-product-root]');
    if (root) {
      activateMedia($('[data-gallery]', root), v.mediaId);
      var fi = $('[data-featured-image] img', root);
      if (fi && v.image) { fi.removeAttribute('srcset'); fi.removeAttribute('sizes'); fi.src = v.image; }
      if (root.hasAttribute('data-main-product') && window.history && history.replaceState) {
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); } catch (err) {}
      }
    }
  }

  /* ---------- quick add ---------- */
  function dialog() { return $('[data-quick-add-dialog]'); }
  function closeDialog() {
    var d = dialog(); if (!d) return;
    if (d.open) { if (d.close) d.close(); else d.removeAttribute('open'); }
  }
  function uniquify(container) {
    $$('[id]', container).forEach(function (el) { el.setAttribute('id', el.getAttribute('id') + '-qa'); });
    $$('[for]', container).forEach(function (el) { el.setAttribute('for', el.getAttribute('for') + '-qa'); });
    $$('[form]', container).forEach(function (el) { el.setAttribute('form', el.getAttribute('form') + '-qa'); });
    $$('input[name^="option-"],select[name^="option-"]', container).forEach(function (el) { el.setAttribute('name', el.getAttribute('name') + '-qa'); });
  }
  function openQuickAdd(url, trigger) {
    var d = dialog(); if (!d) { window.location.href = url; return; }
    if (trigger) trigger.classList.add('is-loading');
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = parse(html), info = $('[data-product-info]', doc);
      if (!info) { window.location.href = url; return; }
      var img = $('.gallery__slide.is-active img', doc) || $('[data-gallery] img', doc) || $('[data-featured-image] img', doc);
      var content = $('[data-quick-add-content]', d);
      content.innerHTML = '';
      var wrap = document.createElement('div'); wrap.className = 'qa';
      if (img) {
        var box = document.createElement('div'); box.className = 'qa__img tile';
        var im = document.createElement('img'); im.src = img.currentSrc || img.src; im.alt = img.alt || '';
        box.appendChild(im); wrap.appendChild(box);
      }
      var holder = document.createElement('div'); holder.appendChild(document.importNode(info, true));
      var infoEl = holder.firstChild; infoEl.classList.remove('is-sticky');
      wrap.appendChild(holder);
      content.appendChild(wrap);
      uniquify(content);
      var all = document.createElement('p'); var a = document.createElement('a');
      a.className = 'link'; a.href = url; a.textContent = (hs.strings.viewFull || 'View full details'); all.appendChild(a);
      holder.appendChild(all);
      if (d.showModal) d.showModal(); else d.setAttribute('open', '');
    }).catch(function () { window.location.href = url; })
      .then(function () { if (trigger) trigger.classList.remove('is-loading'); });
  }

  /* ---------- search ---------- */
  var searchTimer, searchCtl;
  function openSearch() {
    var m = $('[data-search-modal]'); if (!m) { window.location.href = hs.routes.search; return; }
    m.hidden = false; lock(true);
    var i = $('[data-search-input]', m); if (i) setTimeout(function () { i.focus(); }, 30);
  }
  function closeSearch() {
    var m = $('[data-search-modal]'); if (!m || m.hidden) return;
    m.hidden = true;
    if (!(drawer() && drawer().classList.contains('is-open'))) lock(false);
  }
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches('[data-search-input]')) return;
    var q = t.value.trim(), out = $('[data-search-results]');
    clearTimeout(searchTimer);
    if (q.length < 2) { out.innerHTML = ''; return; }
    searchTimer = setTimeout(function () {
      if (searchCtl && searchCtl.abort) searchCtl.abort();
      searchCtl = window.AbortController ? new AbortController() : null;
      var url = hs.routes.predictive + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources%5Btype%5D=product&resources%5Blimit%5D=6';
      fetch(url, searchCtl ? { signal: searchCtl.signal } : {}).then(function (r) { return r.text(); }).then(function (html) {
        var s = $('#shopify-section-predictive-search', parse(html));
        out.innerHTML = s ? s.innerHTML : '';
      }).catch(function () {});
    }, 250);
  });

  /* ---------- recommendations ---------- */
  function loadRecs(scope) {
    $$('[data-recommendations]', scope).forEach(function (el) {
      if (el.getAttribute('data-loaded')) return;
      el.setAttribute('data-loaded', '1');
      var url = el.getAttribute('data-url'); if (!url) return;
      function go() {
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var src = $('[data-recommendations]', parse(html));
          if (src && $('.recs__inner', src)) { el.innerHTML = src.innerHTML; markLoaded(el); }
        }).catch(function () {});
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); go(); } }, { rootMargin: '400px 0px' });
        io.observe(el);
      } else go();
    });
  }

  /* ---------- lazy images fade in as they load ---------- */
  function markLoaded(scope) {
    $$('img', scope || document).forEach(function (img) {
      if (img.complete && img.naturalWidth) img.classList.add('is-loaded');
    });
  }
  document.addEventListener('load', function (e) {
    if (e.target && e.target.tagName === 'IMG') e.target.classList.add('is-loaded');
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-foot-toggle]');
    if (!t) return;
    var col = t.closest('[data-foot-col]'), open = col.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- stacked gallery: highlight the image in view ---------- */
  function trackStacked() {
    var g = $('.gallery--stacked[data-gallery]'); if (!g || window.matchMedia('(max-width: 749px)').matches) return;
    var mid = window.innerHeight * 0.45, best = null, bd = 1e9;
    $$('.gallery__slide', g).forEach(function (s) {
      var r = s.getBoundingClientRect(), d = r.top <= mid && r.bottom >= mid ? 0 : Math.min(Math.abs(r.top - mid), Math.abs(r.bottom - mid));
      if (d < bd) { bd = d; best = s; }
    });
    if (!best) return;
    var id = best.getAttribute('data-media-id');
    $$('.gallery__slide', g).forEach(function (s) { s.classList.toggle('is-active', s === best); });
    $$('.gallery__thumb', g).forEach(function (th) { th.classList.toggle('is-active', th.getAttribute('data-thumb') === id); });
  }
  var stackTick = false;
  window.addEventListener('scroll', function () { if (!stackTick) { stackTick = true; requestAnimationFrame(function () { stackTick = false; trackStacked(); }); } }, { passive: true });

  /* ---------- product card color circles ---------- */
  function pcImg(card) { return $('.pc__img:not(.pc__img--second)', card); }
  function pcShow(card, src) {
    var img = pcImg(card); if (!img || !src) return;
    if (!card.hasAttribute('data-pc-orig')) {
      card.setAttribute('data-pc-orig', img.getAttribute('src') || '');
      card._set = img.getAttribute('srcset'); card._sizes = img.getAttribute('sizes');
    }
    img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = src;
    card.classList.add('is-swapped');
  }
  function pcReset(card) {
    var img = pcImg(card), sel = $('[data-pc-swatch].is-active', card);
    if (sel && sel.getAttribute('data-img')) { pcShow(card, sel.getAttribute('data-img')); return; }
    if (!img || !card.hasAttribute('data-pc-orig')) return;
    if (card._set) img.setAttribute('srcset', card._set); if (card._sizes) img.setAttribute('sizes', card._sizes);
    img.src = card.getAttribute('data-pc-orig'); card.classList.remove('is-swapped');
  }
  function pcSelect(sw) {
    var card = sw.closest('[data-pc]'); if (!card) return;
    $$('[data-pc-swatch]', card).forEach(function (b) { b.classList.toggle('is-active', b === sw); });
    pcShow(card, sw.getAttribute('data-img'));
    var url = sw.getAttribute('data-url');
    if (url) $$('[data-pc-link]', card).forEach(function (a) { a.setAttribute('href', url); });
  }
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('[data-pc-swatch]'); if (!sw) return;
    var card = sw.closest('[data-pc]'); if (card) pcShow(card, sw.getAttribute('data-img'));
  });
  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest && e.target.closest('[data-pc-swatch]'); if (!sw) return;
    var card = sw.closest('[data-pc]'); if (card) pcReset(card);
  });
  document.addEventListener('focusin', function (e) {
    var sw = e.target.closest && e.target.closest('[data-pc-swatch]'); if (!sw) return;
    var card = sw.closest('[data-pc]'); if (card) pcShow(card, sw.getAttribute('data-img'));
  });

  /* ---------- image enlarge ---------- */
  var lbImgs = [], lbIdx = 0;
  function bigSrc(img) {
    var u = img.currentSrc || img.src || '';
    return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=2400') : u;
  }
  function lbShow() { var im = $('.lb__img', $('[data-lb]')); im.src = bigSrc(lbImgs[lbIdx]); im.alt = lbImgs[lbIdx].alt || ''; }
  function openLightbox(img) {
    var g = img.closest('[data-gallery]');
    lbImgs = $$('.gallery__slide img', g); lbIdx = Math.max(0, lbImgs.indexOf(img));
    var box = $('[data-lb]');
    if (!box) {
      box = document.createElement('div'); box.className = 'lb'; box.setAttribute('data-lb', ''); box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true');
      box.innerHTML = '<button class="lb__btn lb__close" type="button" aria-label="Close">&times;</button><button class="lb__btn lb__prev" type="button" data-lb-prev aria-label="Previous">&lsaquo;</button><img class="lb__img" alt=""><button class="lb__btn lb__next" type="button" data-lb-next aria-label="Next">&rsaquo;</button>';
      document.body.appendChild(box);
    }
    box.hidden = false; lock(true); lbShow();
    var multi = lbImgs.length > 1;
    $('[data-lb-prev]', box).style.display = multi ? '' : 'none'; $('[data-lb-next]', box).style.display = multi ? '' : 'none';
  }
  function lbStep(d) { lbIdx = (lbIdx + d + lbImgs.length) % lbImgs.length; lbShow(); }
  function closeLightbox() { var b = $('[data-lb]'); if (b && !b.hidden) { b.hidden = true; lock(false); } }
  document.addEventListener('keydown', function (e) {
    var b = $('[data-lb]'); if (!b || b.hidden) return;
    if (e.key === 'ArrowLeft') lbStep(-1); else if (e.key === 'ArrowRight') lbStep(1);
  });

  /* ---------- featured color circles ---------- */
  function pickFeaturedColor(sw) {
    var card = sw.closest('[data-featured-card]'); if (!card) return;
    $$('[data-fc-swatch]', card).forEach(function (b) {
      var on = b === sw; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var nm = $('[data-fc-name]', card); if (nm) nm.textContent = sw.getAttribute('data-name');
    var url = sw.getAttribute('data-url');
    if (url) $$('[data-fc-link]', card).forEach(function (a) { a.setAttribute('href', url); });
    var src = sw.getAttribute('data-img'), link = $('[data-fc-image-link]', card), img = link && $('img', link);
    if (src && img && img.getAttribute('src') !== src) {
      link.classList.add('is-swapping');
      var pre = new Image();
      var done = function () { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = src; link.classList.remove('is-swapping'); };
      pre.onload = done; pre.onerror = done; pre.src = src;
    }
  }

  /* ---------- announcement rotator ---------- */
  function initAnnounce(bar) {
    if (bar.getAttribute('data-ready')) return;
    bar.setAttribute('data-ready', '1');
    var items = $$('.announce__item', bar);
    if (items.length < 2) return;
    var secs = parseFloat(bar.getAttribute('data-interval')) || 5, idx = 0, paused = false;
    function show(n) {
      items[idx].classList.remove('is-current'); idx = (n + items.length) % items.length; items[idx].classList.add('is-current');
    }
    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    bar.addEventListener('focusin', function () { paused = true; });
    bar.addEventListener('focusout', function () { paused = false; });
    if (!reduce) setInterval(function () { if (!paused && !document.hidden) show(idx + 1); }, secs * 1000);
  }

  /* ---------- header behaviour ---------- */
  var hdrBound = false, lastY = 0;
  function onHeaderScroll() {
    var hd = $('[data-header]'); if (!hd) return;
    var y = window.pageYOffset || 0;
    hd.classList.toggle('is-scrolled', y > 8);
    if (hd.getAttribute('data-sticky') === 'scroll-up') {
      var nav = $('[data-site-nav]', hd);
      var menuOpen = nav && nav.classList.contains('is-open');
      if (y > lastY && y > 140 && !menuOpen) hd.classList.add('is-hidden'); else if (y < lastY) hd.classList.remove('is-hidden');
    }
    lastY = y;
  }
  function initHeader() {
    var hd = $('[data-header]'); if (!hd) return;
    onHeaderScroll();
    if (!hdrBound) { hdrBound = true; window.addEventListener('scroll', onHeaderScroll, { passive: true }); }
  }

  /* ---------- statement (words light up on scroll) ---------- */
  function setHeaderOffset() {
    var h = $('#shopify-section-header'), v = 0, hd = $('[data-header]');
    if (h && getComputedStyle(h).position === 'sticky' && !(hd && hd.getAttribute('data-sticky') === 'scroll-up')) v = h.offsetHeight;
    document.documentElement.style.setProperty('--header-h', v + 'px');
    document.documentElement.style.setProperty('--hdr-total', (hd ? hd.offsetHeight : 72) + 'px');
  }
  function initStatement(sec) {
    if (sec.getAttribute('data-ready')) return;
    sec.setAttribute('data-ready', '1');
    var p = $('[data-words]', sec), h = parseFloat(sec.getAttribute('data-height')) || 140;
    if (!p || reduce || h <= 100) return;
    var words = p.textContent.trim().split(/\s+/);
    p.textContent = '';
    var spans = words.map(function (w, i) {
      var s = document.createElement('span'); s.textContent = w; p.appendChild(s);
      if (i < words.length - 1) p.appendChild(document.createTextNode(' '));
      return s;
    });
    sec.style.setProperty('--hs-h', h + 'vh');
    sec.classList.add('is-active');
    var ticking = false;
    function frame() {
      ticking = false;
      var r = sec.getBoundingClientRect(), span = r.height - window.innerHeight;
      var pr = span > 0 ? Math.min(1, Math.max(0, -r.top / span)) : 1;
      var k = Math.min(1, pr * 1.6) * spans.length;
      for (var i = 0; i < spans.length; i++) spans[i].style.opacity = Math.min(1, Math.max(0.18, 0.18 + (k - i) * 0.9));
    }
    function on() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', on, { passive: true });
    window.addEventListener('resize', on);
    frame();
  }

  function init(scope) {
    scope = scope || document;
    setHeaderOffset();
    markLoaded(scope);
    trackStacked();
    initHeader();
    $$('[data-announce]', scope).forEach(initAnnounce);
    $$('[data-statement]', scope).forEach(initStatement);
    loadRecs(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  window.addEventListener('resize', setHeaderOffset);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
